import UNIQUE from '@/common/unique'

export default {
  id: 'weather',
  name: 'weather',
  type: 'standard',
  moduleName: 'editor_module_weather',
  hide: true,
  dataSet: {
    mods: 'weather',
    column: [
      {
        columnId: '',
        type: 'weather'
      }
    ]
  },
  setting: {
    layout: {
      options: []
    },
    action: null,
    detail: null
  }
}
